const locale = {
  CANCEL_BUTTON: 'Cancel',
  DONE_BUTTON: 'Done',
};

export default locale;
